export enum MaxInputNumber {
  ONE_HUNDRED = 100,
  TWO_HUNDRED_SEVENTY = 270,
}
